import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { Button as r } from "../../forms/button/index.js";
import { Card as p } from "../../containers/card/index.js";
import "react";
import '../../../assets/marketplace.css';const h = "_market_xrzjw_1", k = "_button__primary_xrzjw_29", b = "_button__link_xrzjw_80", i = {
  market: h,
  "market--info": "_market--info_xrzjw_9",
  "market--info--title": "_market--info--title_xrzjw_15",
  "market--info--content": "_market--info--content_xrzjw_19",
  "market--info--actions": "_market--info--actions_xrzjw_24",
  button__primary: k,
  "market--cards": "_market--cards_xrzjw_34",
  "card-header": "_card-header_xrzjw_41",
  "card-content": "_card-content_xrzjw_56",
  button__link: b
};
function j({
  cards: n = [
    {
      header: "Inserte imagen aqui",
      children: /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("h4", { children: "Principales tendencias" }),
        /* @__PURE__ */ a("p", { children: [
          "Destaca tu marca personal con hashtags personalizados como",
          " ",
          /* @__PURE__ */ a("strong", { children: [
            /* @__PURE__ */ e("span", { children: "#" }),
            "JuanRealEstate"
          ] }),
          " ",
          "y menciona a colegas o tu inmobiliaria para potenciar tu visibilidad 🏠✨."
        ] })
      ] })
    },
    {
      header: "Inserte imagen aqui",
      children: /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("h4", { children: "Propiedad certificada" }),
        /* @__PURE__ */ e("p", { children: "Las propiedades que superan nuestro estricto proceso de verificación aparecen como certificadas en nuestro marketplace, ofreciendo mayor seguridad a tus clientes potenciales." })
      ] })
    },
    {
      header: "Inserte imagen aqui",
      children: /* @__PURE__ */ a("div", { children: [
        /* @__PURE__ */ e("h4", { children: "Sin intermediarios" }),
        /* @__PURE__ */ e("p", { children: "En nuestro marketplace, facilitamos comunicaciones directas con interesados a través de WhatsApp, sin intermediarios." })
      ] })
    }
  ],
  content: t = "Además de ofrecer seguridad a nuestros clientes en el sector inmobiliario gracias a nuestras verificaciones y todas las facilidades para regularizar sus inmuebles, hemos creado un marketplace inmobiliario donde puedes publicar todas tus propiedades en venta o alquiler sin ningún costo. Este servicio adicional maximiza tu alcance y potencia tu visibilidad",
  exploreButtonContent: o = "Explorar el Feed Inmobiliario",
  onClickExploreButton: c = () => {
  },
  subtitle: s = "Amplía tu horizonte inmobiliario",
  title: l = "Descubre nuestro marketplace inmobiliario",
  onClickTendencyButton: d = () => {
  },
  tendencyButtonContent: m = "Descubrir las Tendencias"
}) {
  return /* @__PURE__ */ a("section", { className: `${i.market}`, children: [
    /* @__PURE__ */ a("article", { className: `${i["market--info"]}`, children: [
      /* @__PURE__ */ e("h5", { className: `${i["market--info--subtitle"]} b-mb-4 md:b-mb-2`, children: s }),
      /* @__PURE__ */ e("h2", { className: `${i["market--info--title"]} b-mb-6`, children: l }),
      /* @__PURE__ */ e("div", { className: `${i["market--info--content"]} b-mb-6 md:b-mb-0`, children: t }),
      /* @__PURE__ */ a("div", { className: `${i["market--info--actions"]}`, children: [
        /* @__PURE__ */ e(r, { className: "lg:!b-w-auto", onClick: c, children: o }),
        /* @__PURE__ */ e(r, { onClick: d, styleType: "link", children: m })
      ] })
    ] }),
    n.map((u, _) => /* @__PURE__ */ e("article", { className: `${i["market--cards"]}`, children: /* @__PURE__ */ e(p, { ...u }) }, _))
  ] });
}
export {
  j as default
};
